import BrandLogo from '../components/BrandLogo';
import { useState } from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Mail, ArrowRight, Loader } from 'lucide-react';
import SEOHead from '../components/SEOHead';
import { authManager } from '../services/authManager';

export default function ForgotPasswordPage() {
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!email) {
      setError('Por favor ingresa tu email');
      return;
    }
    
    setLoading(true);
    setError('');
    
    try {
      await authManager.forgotPassword(email);
      setSuccess(true);
    } catch (error) {
      setError(error.message || 'Error en el servidor. Por favor intenta de nuevo.');
    } finally {
      setLoading(false);
    }
  };

  if (success) {
    return (
      <div className="min-h-screen bg-morado/5 flex items-center justify-center p-4">
        <motion.div
          initial={{ opacity: 0, scale: 0.9 }}
          animate={{ opacity: 1, scale: 1 }}
          className="max-w-md w-full bg-white rounded-2xl shadow-xl p-8 border border-[#d4af37] text-center"
        >
          <div className="w-16 h-16 mx-auto mb-4 rounded-full bg-green-100 flex items-center justify-center text-green-600 text-3xl">
            ✓
          </div>
          <h2 className="text-2xl font-bold text-morado mb-2">
            ¡Email Enviado!
          </h2>
          <p className="text-gray-600 mb-6">
            Te hemos enviado un enlace para resetear tu contraseña. Por favor revisa tu bandeja de entrada.
          </p>
          <Link
            to="/login"
            className="inline-block w-full bg-morado text-white py-3 rounded-xl font-semibold hover:shadow-lg transition-all"
          >
            Volver al inicio de sesión
          </Link>
        </motion.div>
      </div>
    );
  }

  return (
    <>
      <SEOHead 
        title="Recuperar Contraseña - Numerathum"
        description="Recupera el acceso a tu cuenta"
        noindex={true}
      />
      <div className="min-h-screen bg-morado/5 flex items-center justify-center p-4">
        <div className="max-w-md w-full">
          {/* Header */}
        <motion.div 
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          className="text-center mb-8"
        >
          <Link to="/" className="inline-block mb-4">
            <BrandLogo className="w-64" />
          </Link>
          <h1 className="text-3xl font-bold text-morado mb-2">Recuperar Contraseña</h1>
          <p className="text-gray-600">Te enviaremos un enlace para resetear tu contraseña</p>
        </motion.div>

        {/* Form */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.1 }}
          className="bg-white rounded-2xl shadow-xl p-8 border border-[#d4af37]"
        >
          <form onSubmit={handleSubmit} className="space-y-6">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Email
              </label>
              <div className="relative">
                <Mail className="absolute left-3 top-1/2 transform -translate-y-1/2 w-5 h-5 text-gray-400" />
                <input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className="w-full pl-10 pr-4 py-3 rounded-xl border border-gray-300 focus:ring-2 focus:ring-morado focus:border-transparent"
                  placeholder="tu@email.com"
                />
              </div>
            </div>

            {error && (
              <div className="bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded-xl text-sm">
                {error}
              </div>
            )}

            <button
              type="submit"
              disabled={loading}
              className="w-full bg-morado text-white py-3 rounded-xl font-semibold flex items-center justify-center gap-2 hover:shadow-lg transition-all duration-300 disabled:opacity-50"
            >
              {loading ? (
                <>
                  <Loader className="w-5 h-5 animate-spin" />
                  Enviando...
                </>
              ) : (
                <>
                  Enviar Enlace
                  <ArrowRight className="w-5 h-5" />
                </>
              )}
            </button>
          </form>

          <div className="mt-6 text-center">
            <Link
              to="/login"
              className="text-sm text-gray-600 hover:text-morado"
            >
              ← Volver al inicio de sesión
            </Link>
          </div>
        </motion.div>
      </div>
    </div>
    </>
  );
}

